import React from 'react';
import './ValuesQ6.scss';
import ValuesQuestion from '../shared/ValuesQuestion.jsx'
const locator = require('./Locator_5.png')

const definitelyPic = require('./Def_blue.png')
const probablyPic = require('./Prob_blue.png')
const doesntMatterPic = require('./DsntMatter_blue.png')
const probablyNotPic = require('./ProbNot_blue.png')
const definitelyNotPic = require('./DefNot_blue.png')

const definitelyDesktopPic = require('./desktop/Def_blue.png')
const probablyDesktopPic = require('./desktop/Prob_blue.png')
const doesntMatterDesktopPic = require('./desktop/DsntMatter_blue.png')
const probablyNotDesktopPic = require('./desktop/ProbNot_blue.png')
const definitelyNotDesktopPic = require('./desktop/DefNot_blue.png')

const ValuesQ6 = ({ answer, setAnswer, lexicon, answersLexicon, studyId }) => {

  return (
    <div id="ValuesQ6">
        <ValuesQuestion 
          question="q6"
          answer={answer} 
          setAnswer={setAnswer} 
          lexicon={lexicon} 
          answersLexicon={answersLexicon} 
          definitelyPic={definitelyPic} 
          probablyPic={probablyPic} 
          doesntMatterPic={doesntMatterPic} 
          probablyNotPic={probablyNotPic} 
          definitelyNotPic={definitelyNotPic} 
          definitelyDesktopPic={definitelyDesktopPic} 
          probablyDesktopPic={probablyDesktopPic} 
          doesntMatterDesktopPic={doesntMatterDesktopPic} 
          probablyNotDesktopPic={probablyNotDesktopPic} 
          definitelyNotDesktopPic={definitelyNotDesktopPic} 
          backPath="/values-q5"
          nextPath="/summary"
          locator={locator}
          studyId={studyId}
        />
    </div>
  );
}

export default ValuesQ6 ;
